export const projectConstant = [
  {
    id: "4",
    title: "Click & Craf",
    details: [
      `In this project, the user experiences an animated landing page.`,
      "Next.js 14, Typescript, Redux toolkit, Tailwind",
    ],
    imgLink: "./img/click-and-craft.webp",
    previewLink: "https://click-and-craft.vercel.app/",
    codeLink: "https://github.com/elifcifci/click-craft",
    selected: false,
  },
  {
    id: "3",
    title: "Evil Morty",
    details: [
      `This website contains web pages that you can visit by clicking on portals or by driving the spaceship with the keyboard.`,
      "React, Typescript, Redux toolkit, Axios, Scss",
    ],
    imgLink: "./img/evil-morty.png",
    previewLink: "https://evil-morty.vercel.app/",
    codeLink: "https://github.com/elifcifci/evil-morty",
    selected: false,
  },
  {
    id: "2",
    title: "Chuck Norris Facts",
    details: [
      ` This website contains "Chuck Norris facts". Within the site, you can find jokes from different categories, temporarily add them to your basket or permanently save them to your saved page. You can create different users. Users' information is stored in localStorage.`,
      " Javascript, react, CSS module, ant design",
    ],
    imgLink: "./img/joke-create.png",
    previewLink: "https://joke-generator-psi.vercel.app/",
    codeLink: "https://github.com/elifcifci/joke-generator",
    selected: false,
  },
  {
    id: "1",
    title: "Rockstart Games Clone",
    details: [
      `In this project, the version of website "Rockstart Games" in 2022 has been cloned.`,
      "Javascript, react, styled component, framer motion",
    ],
    imgLink: "./img/rockstar-clone.jpg",
    previewLink: "https://rockstar-games-clone-website.netlify.app/",
    codeLink: "https://github.com/elifcifci/rockstar-games-clone",
    selected: false,
  }
];
